// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!../node_modules/normalize.css/normalize.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Montserrat-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/Montserrat-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/Montserrat-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/Montserrat-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Montserrat Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Montserrat Medium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "Montserrat SemiBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "Montserrat ExtraBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-weight: 800;
  font-style: normal;
}
html {
  height: 100%;
  scroll-behavior: auto;
}

body {
  overflow-x: hidden;
  height: 100%;
  background: #efeffc;
  font-weight: 400;
}

* {
  box-sizing: border-box;
}

img {
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-track {
  display: none;
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: #1A193C;
  display: none;
  border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/fonts.scss","webpack://./src/index.scss","webpack://./src/assets/styles/global.scss"],"names":[],"mappings":"AAAA;EACE,iCAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;ACEF;ADCA;EACE,gCAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;ACCF;ADCA;EACE,kCAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;ACCF;ADEA;EACE,mCAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;ACAF;ACtBA;EACE,YAAA;EACA,qBAAA;ADwBF;;ACrBA;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;ADwBF;;ACrBA;EACE,sBAAA;ADwBF;;ACrBA;EACE,uBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;ADwBF;;AA1CA;EACE,UAAA;EACA,WAAA;AA6CF;;AA1CA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AA6CF;;AA1CA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;AA6CF","sourcesContent":["@font-face {\r\n  font-family: 'Montserrat Regular';\r\n  src: url('../fonts/Montserrat-Regular.ttf') format('truetype');\r\n  font-weight: 400;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: 'Montserrat Medium';\r\n  src: url('../fonts/Montserrat-Medium.ttf') format('truetype');\r\n  font-weight: 500;\r\n  font-style: normal;\r\n}\r\n@font-face {\r\n  font-family: 'Montserrat SemiBold';\r\n  src: url('../fonts/Montserrat-SemiBold.ttf') format('truetype');\r\n  font-weight: 600;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: 'Montserrat ExtraBold';\r\n  src: url('../fonts/Montserrat-ExtraBold.ttf') format('truetype');\r\n  font-weight: 800;\r\n  font-style: normal;\r\n}\r\n","@import '~@assets/styles/fonts.scss';\r\n@import '~normalize.css/normalize.css';\r\n@import '~@assets/styles/global.scss';\r\n@import '~@assets/styles/colorsVariables.scss';\r\n\r\n::-webkit-scrollbar {\r\n  width: 5px;\r\n  height: 5px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  display: none;\r\n  box-shadow: inset 0 0 5px grey;\r\n  border-radius: 10px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: #1A193C;\r\n  display: none;\r\n  border-radius: 10px;\r\n}\r\n","@import './mixins.scss';\r\n\r\nhtml {\r\n  height: 100%;\r\n  scroll-behavior: auto;\r\n}\r\n\r\nbody {\r\n  overflow-x: hidden;\r\n  height: 100%;\r\n  background: #efeffc;\r\n  font-weight: 400;\r\n}\r\n\r\n* {\r\n  box-sizing: border-box;\r\n}\r\n\r\nimg {\r\n  -webkit-user-drag: none;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
